import React from "react";
import ForNoVideoFound from "../ForNoVideoFound";

export default function WatchLaterComponent() {
  return (
    <div>
      <ForNoVideoFound />
    </div>
  );
}
